import { ModuleContent } from '../contract';

/**
 * Content for the Image module.
 */
export type ImageModuleContent = {
	src: string;
	alt?: string;
};

export function isImageModuleContent(content: ModuleContent): content is ImageModuleContent {
	return typeof (content as ImageModuleContent).src === 'string';
}

/**
 * Returns alt text for indexing (images have limited textual content).
 */
export function getImageModuleIndexableText(content: ModuleContent): string {
	if (!isImageModuleContent(content)) return '';
	return (content.alt ?? '').trim();
}
